import { css, html } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../../atom/Icon/index.js";
import "../../atom/UploadProgress/index.js";
import "../Button/index.js";
import "../Link/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { rif } from "../../../helpers/renderIf.js";
import { fileSizeInMbFormatted, getWrapperClasses, getMessageClasses, timestampFormatted } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfFileCard = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_file_size = 0;
    this.dsf_locale = navigator.language;
    this.dsf_error = false;
    this.dsf_delete_displayed = false;
  }
  get isUploading() {
    return this.dsf_upload_progress !== void 0;
  }
  handleLinkClick() {
    this.emit("file-click");
  }
  handleDeleteClick() {
    this.emit("delete-click");
  }
  render() {
    const fileName = html`<div class="flex flex-auto items-baseline gap-8">
      ${!this.dsf_error ? html`<dsf-link
            class="dsf-file-link shrink truncate"
            dsf_size="medium"
            ?disabled=${this.isUploading}
            dsf_href=${ifDefined(this.dsf_file_url)}
            title="${ifDefined(this.dsf_file_name)}"
            @click=${this.handleLinkClick}
            >${this.dsf_file_name}</dsf-link
          >` : html`<span class="dsf-text-xs text-neutral-700">${this.dsf_file_name}</span>`}
      ${rif(
      this.dsf_file_size,
      html`<span class="dsf-text-xxs text-nowrap text-neutral-300"
          >${fileSizeInMbFormatted(this.dsf_file_size)}</span
        >`
    )}
    </div>`;
    return html`<div class=${getWrapperClasses(this)}>
      <div class="flex w-0 flex-auto flex-wrap items-center gap-12">
        <div class="flex max-w-280 flex-auto items-center gap-8 truncate">
          ${rif(
      this.dsf_icon,
      html`<dsf-icon
              dsf_name=${ifDefined(this.dsf_icon)}
              class="h-14 w-12 shrink-0 text-neutral-300"
            ></dsf-icon>`
    )}
          <div class="flex flex-auto flex-col gap-4 truncate">
            ${fileName}
            ${rif(
      this.dsf_message,
      html`<div class="flex items-center gap-4">
                <span class=${getMessageClasses(this)}>${this.dsf_message}</span>
                <span class="dsf-text-xxs text-neutral-300"
                  >${timestampFormatted(this.dsf_timestamp, this.dsf_locale)}</span
                >
              </div>`
    )}
          </div>
        </div>
        ${rif(
      this.dsf_text_title || this.dsf_text_description,
      html`<div class="flex flex-auto flex-col">
            ${rif(
        this.dsf_text_title,
        html`<span class="dsf-text-xxs-semibold text-neutral-700"
                >${this.dsf_text_title}</span
              >`
      )}
            ${rif(
        this.dsf_text_description,
        html`<span class="dsf-text-xxs text-neutral-400">${this.dsf_text_description}</span>`
      )}
          </div>`
    )}
      </div>
      <div class="ml-auto shrink-0">
        ${rif(
      this.isUploading,
      html`<dsf-upload-progress
            dsf_upload_progress=${ifDefined(this.dsf_upload_progress)}
          ></dsf-upload-progress>`
    )}
        ${rif(
      this.dsf_delete_displayed && !this.isUploading,
      html`<dsf-button
            dsf_square
            dsf_level="secondary"
            dsf_icon_left="Trash2"
            dsf_size="small"
            dsf_accessibility_label=${ifDefined(this.dsf_delete_accessibility_label)}
            @click=${this.handleDeleteClick}
          >
          </dsf-button>`
    )}
      </div>
    </div>`;
  }
};
DsfFileCard.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfFileCard.styles = [
  ...BaseComponent.styles,
  css`
      .dsf-file-link::part(link) {
        display: inline;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_file_name", 2);
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_file_url", 2);
__decorateClass([
  prop({ type: Number })
], DsfFileCard.prototype, "dsf_file_size", 2);
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_message", 2);
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_timestamp", 2);
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_locale", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfFileCard.prototype, "dsf_error", 2);
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_upload_progress", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfFileCard.prototype, "dsf_icon", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfFileCard.prototype, "dsf_delete_displayed", 2);
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_delete_accessibility_label", 2);
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_text_title", 2);
__decorateClass([
  prop({ type: String })
], DsfFileCard.prototype, "dsf_text_description", 2);
DsfFileCard = __decorateClass([
  defineElement("dsf-file-card")
], DsfFileCard);
export {
  DsfFileCard
};
